// extracted by mini-css-extract-plugin
module.exports = {"default":"Color_default__1svRo","purple":"Color_purple__264xF"};